import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { DataMainTemplate } from "@nocios/presentation-kit";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import AnimtionLeftPanelBlue from "src/Component/AnimtionLeftPanelBlue";

// Constants
const PAGE_ID = 6;
const BG_ID = 6;
const BG_TYPE = "jpg";
const NEXT_PAGE_ID = PAGE_ID + 1;
const BACK_PAGE_ID = PAGE_ID - 1;
// const LAST_PAGE = false;

const LEFT_TITLE = "AI Driven Jeopardy engine";

// Main data function that returns the template data
const DATA = (): DataMainTemplate => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const currentPage = useSelector((state: { appReducer: { currentPage: number } }) => state.appReducer.currentPage);

  const baseImageBG = `${Config.BASE_URL}/images/BG/`;

  const backButton =
    BACK_PAGE_ID > 0
      ? {
          label: "Back",
          type: "back" as const,
          startIcon: { icon: "arrow-right", color: "#fff" },
          onClick: () => setCurrentPage(BACK_PAGE_ID),
          style: {
            borderRadius: "45px",
            padding: "var(--width-5) var(--width-25)",
            gap: "var(--width-16)",
          },
        }
      : undefined;

  const nextButton = {
    label: "Next",
    type: "next" as const,
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NEXT_PAGE_ID),
    style: {
      borderRadius: "45px",
      padding: "var(--width-5) var(--width-25)",
      gap: "var(--width-16)",
    },
  };

  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (PAGE_ID === currentPage) {
      if (videoRef.current) videoRef.current.play();

      timer = setTimeout(() => {
        setStartAnimation(true);
      }, 300);
    } else {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }

      setStartAnimation(false);
    }

    return () => clearTimeout(timer);
  }, [currentPage]);

  const [step, setStep] = useState(0);

  useEffect(() => {
    if (currentPage === PAGE_ID) {
      setTimeout(() => {
        setStep(1);
      }, 700);
    } else {
      setStep(0);
    }
  }, [currentPage]);

  return {
    styleBody: { marginTop: 0 },
    bgVideo: {
      poster: `${baseImageBG}BG_${BG_ID}.${BG_TYPE}`,
      video: `${Config.BASE_URL}/videos/bg_${BG_ID}.mp4`,
    },
    gradient:
      "linear-gradient(270deg, rgba(21, 50, 121, 0.00) 11.77%, #153279 87.81%), linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%)",

    title: LEFT_TITLE,
    description:
      '<ul id="ilo-ul-screen-8"><li>E2E Order Visibility & Autonomous Business Operations</li><li>Dependency tracing</li><li>AI/ML Model forecasting delays</li><li>Loop Processing to identify and fix Root cause</li><li>Proactive alerts to Customer Service Representative</li></ul>',
    leftAfterDescription: (
      <AnimtionLeftPanelBlue
        style={{
          width: "var(--width-435)",
          left: "calc(-1 * var(--width-102))",
          top: "var(--height-50)",
        }}
        startAnimation={startAnimation}
        image={`${Config.BASE_URL}/images/screen_${PAGE_ID}/left_0.png`}
      />
    ),
    rightSideComponent: (
      <>
        <img
          style={{
            width: "var(--width-1250)",
            transition: "all 0.4s ease",
            right: 0,
            top: 0,
            position: "absolute",
            opacity: step >= 1 ? 1 : 0,
            zIndex: 5,
          }}
          src={`${Config.BASE_URL}/images/screen_6/label.png`}
          alt=""
        />
        <video
          ref={videoRef}
          style={{
            width: "var(--width-1190)",
            height: "var(--height-669)",
            position: "absolute",
            bottom: "var(--height-232)",
            right: 0,
            zIndex: 4,
            transformOrigin: "center",
            objectFit: "cover",
          }}
          src={`${Config.BASE_URL}/videos/screen_6.mp4`}
          muted
          controls={true}
        />
      </>
    ),
    next: nextButton,
    back: backButton,
  };
};

export default DATA;
